<div class="prelogin-body">
    <div class="content-width">
        <div class="prelogin-form-card-container">
            <app-activate-user *ngIf="!canActivate" (showCompleteProfile)="completeProfile($event)"></app-activate-user>
            <app-complete-profile *ngIf="canActivate && !selfRegistrationIsEnabled" [user]="user"></app-complete-profile>
            <app-complete-profile-self-registration *ngIf="canActivate && selfRegistrationIsEnabled" [user]="user"></app-complete-profile-self-registration>
        </div>
    </div>
</div>